<template>
  <div>
    <vs-row vs-justify="center">
      <vs-col vs-lg="8" vs-xs="12" vs-sm="12" style="padding-bottom: 20px;">
        <vs-card style="height: 100%;">
          <vs-row>
            <vs-col
              vs-lg="3"
              vs-md="4"
              vs-sm="6"
              vs-xs="12"
              class="d-flex align-items-center"
            >
              <vs-input
                :label="$t('Time.From')"
                timezone="FR-fr"
                :max="filter.end_dat"
                type="date"
                class="w-100 mb-4"
                v-model="filter.start_date"
              />
            </vs-col>
            <vs-col
              vs-lg="3"
              vs-md="4"
              vs-sm="6"
              vs-xs="12"
              class="d-flex align-items-center"
            >
              <vs-input
                :label="$t('Time.To')"
                timezone="FR-fr"
                :max="new Date().toISOString().split('T')[0]"
                :min="filter.start_date"
                type="date"
                class="w-100 mb-4"
                v-model="filter.end_date"
              />
            </vs-col>

            <vs-col vs-lg="6" vs-md="4" vs-sm="6" vs-xs="12" class="d-flex">
              <vs-input
                :label="$t('Feedbacks.Filter.search')"
                :placeholder="$t('Feedbacks.Filter.searchPlaceholder')"
                type="text"
                class="w-100 mb-4"
                v-model="filter.keyword"
              />
            </vs-col>
            <!-- <vs-col vs-lg="3" vs-md="4" vs-sm="6" vs-xs="12" class="d-flex align-items-center">
                    <BusinessSelectFilter :multiselect="true" v-on:selectBusiness="loadSmsByRange" style="z-index: 9999999999;"></BusinessSelectFilter>
                </vs-col> -->
          </vs-row>
          <!-- ******************************** -->
          <vs-row>
            <vs-col
              vs-lg="3"
              vs-md="4"
              vs-sm="6"
              vs-xs="12"
              class="d-flex align-items-center"
            >
              <vs-select
                :label="$t('Feedbacks.Filter.stars')"
                class="w-100 mb-4"
                v-model="filter.rating"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in optionsStars"
                />
              </vs-select>
            </vs-col>
            <vs-col
              vs-lg="6"
              vs-md="4"
              vs-sm="6"
              vs-xs="12"
              class="d-flex align-items-center"
            >
              <BusinessSelectFilter
                :multiselect="true"
                v-on:selectBusiness="filterByBuisiness"
              ></BusinessSelectFilter>
            </vs-col>

            <!-- <vs-col vs-lg="3" vs-md="4" vs-sm="6" vs-xs="12" class="d-flex align-items-center">
                    <BusinessSelectFilter :multiselect="true" v-on:selectBusiness="loadSmsByRange" style="z-index: 9999999999;"></BusinessSelectFilter>
                </vs-col> -->
            <vs-col
              vs-lg="3"
              vs-md="4"
              vs-sm="6"
              vs-xs="12"
              class="d-flex align-items-center"
            >
              <button
                class="btn btn-primary"
                style="border-radius: 5px; width: 100%"
                @click="initPage()"
              >
                {{ $t("Filter.filterButton") }}
              </button>
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-col>
      <vs-col vs-lg="4" vs-md="12" vs-sm="12" vs-xs="12">
        <FeedbackSummary
          v-if="feedbackSummary && totalItems"
          id="feedback-listing"
          :data="feedbackSummary"
          :total="totalItems"
          :rating="rating"
        ></FeedbackSummary>
      </vs-col>
    </vs-row>
    
      
    <vs-row vs-justify="center">
      <vs-col vs-lg="12" vs-md="12" vs-sm="12" vs-xs="12">
        <div>
          <vs-card>
            <vs-table
              :data="feedback"
              id="feedback-box"
              max-items="10"
              :total="totalItems"
            >
              <template slot="thead">
                <vs-th>{{ $t("Menu.Business") }}</vs-th>
                <vs-th>{{ $t("Feedbacks.Table.Name") }}</vs-th>
                <vs-th>{{ $t("Booking.CreatePrompt.StartDate") }}</vs-th>
                <!-- <vs-th>{{ $t("Feedbacks.Table.Email") }}</vs-th> -->
                <!-- <vs-th>{{ $t("Feedbacks.Table.Feedback") }}</vs-th>
                <vs-th>{{ $t("Booking.CreatePrompt.StartDate") }}</vs-th>
                <vs-th>{{ $t("Statistics.Tabs.Time.Title") }}</vs-th> -->
                <vs-th>{{ $t("Feedbacks.Table.Rating") }}</vs-th>
                <vs-th>{{ "Plus d'informations" }}</vs-th>
              </template>
              <template>
                <vs-tr :key="index" v-for="(item, index) in feedback">
                  <vs-td
                    ><b>{{ item.business_name }}</b></vs-td
                  >
                  <vs-td>
                    <span v-if="item.fname && item.fname != 'null'">
                      <b>{{ item.fname + " " + item.lname }}</b
                      ><br />
                      <span v-if="item.phone_number" style="color: #888">{{
                        item.phone_number
                      }}</span>
                    </span>
                    <span v-else>
                      <b>{{ $t("Components.Queue.TicketItem.Anonymous") }}</b
                      ><br />
                      <span v-if="item.phone_number" style="color: #888">{{
                        item.phone_number
                      }}</span>
                    </span>
                    <div>  
                      <span v-if="item.email" style="color: #888">{{
                        item.email
                      }}</span>
                      <span v-else style="color: #888">{{
                        "--"
                      }}</span>
                    </div>
                  </vs-td>

                  <!-- <vs-td v-if="item.email">{{ item.email }}</vs-td>
                  <vs-td v-else>--</vs-td> -->
                  <vs-td v-if="item.checkinDate && item.checkinTime">{{ $moment(item.checkinDate).format('Do MMMM YYYY') + " " + item.checkinTime }}</vs-td>
                  <vs-td v-else>--</vs-td>
                  <!-- <vs-td>{{ item.feedback }}</vs-td>
                  <vs-td>{{ item.checkinDate }}</vs-td>
                  <vs-td>{{ item.checkinTime }}</vs-td> -->
                  <vs-td>
                    <span>
                      <i
                        class="mdi mdi-star rating-star"
                        style="font-size: 16px"
                        :key="index + '-avg-full'"
                        v-for="index in item.rating"
                      ></i>
                      <i
                        class="mdi mdi-star-outline rating-star"
                        style="font-size: 16px"
                        :key="index + '-avg-empty'"
                        v-for="index in 5 - item.rating"
                      ></i>
                    </span>
                  </vs-td>
                  <vs-td>
                    <button
                      class="btn btn-primary"
                      style="border-radius: 5px; width: 60%"
                      @click="
                        getFeedbackById(item.id)
                      "
                    >
                      {{ $t("Components.Widgets.BookingSummary.Details") }}
                    </button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-pagination
              :total="totalPages"
              @change="handleChangePage"
              v-model="currentPage"
            ></vs-pagination>
          </vs-card>
        </div>
      </vs-col>

      <!--V-Tour start-->
      <v-tour name="Feedback" :steps="steps">
        <template slot-scope="tour">
          <transition name="fade">
            <v-step
              v-if="tour.currentStep === index"
              v-for="(step, index) of tour.steps"
              :key="index"
              :step="step"
              :previous-step="tour.previousStep"
              :next-step="tour.nextStep"
              :stop="tour.stop"
              :is-first="tour.isFirst"
              :is-last="tour.isLast"
              :labels="tour.labels"
            >
              <template v-if="tour.currentStep === 0">
                <div slot="actions" class="v-step__buttons">
                  <button @click="goToNextPage" class="v-step__button">
                    Next
                  </button>
                </div>
              </template>
            </v-step>
          </transition>
        </template>
      </v-tour>
    </vs-row>
    <vs-popup
      color="primary"
      class="feedback"
      :buttonAccept="false"
      :buttonCancel="false"
      :active.sync="activeViewPrompt"
      :title="
        $t('Components.Widgets.BookingSummary.Details') +
        ' ' +
        $t('Feedbacks.Table.Feedback')
      "
      :cancel-text="$t('Customer.CreateCustomerPrompt.CancelButton')"
    >
      <div
        v-bar
        class="vs-scrollable"
        style="height: 430px"
        v-if="selectedFeedback"
      >
        <div>
          <div class="con-exemple-prompt px-4 py-3">
            <div class="w-100 mb-2 font-weight-bold">
              <span>{{ $t("Menu.Business") }}</span>
            </div>
            <div class="mb-3">
              <span variant="light">{{
                selectedFeedback.business.name
              }}</span>
            </div>

            <vs-row
              v-if="selectedFeedback.fname && selectedFeedback.fname != 'null'"
            >
              <vs-col vs-w="6">
                <div class="w-100 mb-2 font-weight-bold">
                  <span>{{ $t("Customer.FirstName") }}</span>
                </div>
                <div class="mb-3">
                  <span variant="light">{{
                    selectedFeedback.fname
                  }}</span>
                </div>
              </vs-col>
              <vs-col vs-w="6">
                <div class="w-100 mb-2 font-weight-bold">
                  <span>{{ $t("Customer.LastName") }}</span>
                </div>
                <div class="mb-3">
                  <span variant="light">{{
                    selectedFeedback.lname
                  }}</span>
                </div>
              </vs-col>
            </vs-row>
            <vs-row v-else>
              <vs-col vs-w="6">
                <div class="w-100 mb-2 font-weight-bold">
                  <span>{{ $t("Customer.FirstName") }}</span>
                </div>
                <div class="mb-3">
                  <span variant="light">{{ anonym }}</span>
                </div>
              </vs-col>
              <vs-col vs-w="6">
                <div class="w-100 mb-2 font-weight-bold">
                  <span>{{ $t("Customer.LastName") }}</span>
                </div>
                <div class="mb-3">
                  <span variant="light">{{ anonym }}</span>
                </div>
              </vs-col>
            </vs-row>
            <div class="w-100 mb-2 font-weight-bold">
              <span>{{ $t("Businesses.PhoneNumber") }}</span>
            </div>
            <div class="mb-3">
              <span variant="light">{{
                selectedFeedback.phone_number
              }}</span>
            </div>

            <div v-if="selectedFeedback.email">
              <div class="w-100 mb-2 font-weight-bold">
                <span>{{ $t("Feedbacks.Table.Email") }}</span>
              </div>
              <div class="mb-3">
                <span variant="light">{{ selectedFeedback.email }}</span>
              </div>
            </div>
            <div v-else>
              <div class="w-100 mb-2 font-weight-bold">
                <span>{{ $t("Feedbacks.Table.Email") }}</span>
              </div>
              <div class="mb-3">--</div>
            </div>

            <div v-if="selectedFeedback.services">
              <div class="w-100 mb-2 font-weight-bold">
                <span>{{ $t("Booking.Services") }}</span>
              </div>
              <div style="display: flex; margin: 14px 0">
                <div
                  class="mb-3"
                  v-for="(item, index) in selectedFeedback.services"
                  :key="index"
                >
                  <span class="badge-services">{{ item.title }}</span>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="w-100 mb-2 font-weight-bold">
                <span>{{ $t("Booking.Services") }}</span>
              </div>
              <div class="mb-3"></div>
            </div>

            <div class="w-100 mb-2 font-weight-bold">
              <span>{{ $t("Feedbacks.Table.Feedback") }}</span>
            </div>
            <div class="mb-3">
              <span variant="light">{{ selectedFeedback.feedback }}</span>
            </div>

            <vs-row>
              <vs-col vs-w="6">
                <div class="w-100 mb-2 font-weight-bold">
                  <span>{{ $t("Booking.CreatePrompt.StartDate") }}</span>
                </div>
                <div class="mb-3">
                  <span variant="light">{{
                    $moment(selectedFeedback.checkinDate).format('Do MMMM YYYY')
                  }}</span>
                </div>
              </vs-col>
              <vs-col vs-w="6">
                <div class="w-100 mb-2 font-weight-bold">
                  <span>{{ $t("Statistics.Tabs.Time.Title") }}</span>
                </div>
                <div class="mb-3">
                  <span variant="light">{{
                    selectedFeedback.checkinTime
                  }}</span>
                </div>
              </vs-col>
            </vs-row>
            <div>
              <span style="font-size: 20px">{{
                $t("Feedbacks.Table.Rating")
              }}</span>
            </div>
            <div>
              <span>
                <i
                  class="mdi mdi-star rating-star"
                  style="font-size: 26px"
                  :key="index + '-avg-full'"
                  v-for="index in selectedFeedback.rating"
                ></i>
                <i
                  class="mdi mdi-star-outline rating-star"
                  style="font-size: 26px"
                  :key="index + '-avg-empty'"
                  v-for="index in 5 - selectedFeedback.rating"
                ></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="w-100 mb-2 font-weight-bold">
          <h3>{{ $t("Customer.NoData") }}</h3>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { feedbacksService } from "../../_services";
import router from "../../_helpers/router";
import FeedbackSummary from "../../components/widgets/feedback/FeedbackSummary";
import BusinessSelectFilter from "../../components/shared/BusinessSelectFilter";

export default {
  name: "Feedback",
  data: () => ({
    anonym: "Anonymous",
    activeViewPrompt: false,
    loading: false,
    selectedFeedback: null,
    optionsStars: [
      { value: null, text: "All stars" },
      { value: 1, text: "1 star" },
      { value: 2, text: "2 star" },
      { value: 3, text: "3 star" },
      { value: 4, text: "4 star" },
      { value: 5, text: "5 star" },
    ],
    totalPages: 1,
    totalItems: 0,
    currentPage: 1,
    title: "Feedback",
    feedback: [],
    feedbackSummary: {},
    rating: 0,
    steps: [
      {
        target: "#feedback-listing", // We're using document.querySelector() under the hood
        params: {
          placement: "auto", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
    ],
    filter: {
      start_date: null,
      end_date: null,
      keyword: null,
      rating: null,
      agency: null,
    },
  }),
  methods: {
    reset() {
      this.activeViewPrompt = false;
    },
    getFeedbackById(id) {
      this.loading = true;
      this.showLoading();
      feedbacksService
        .getById(id)
        .then(
          function (data) {
            this.selectedFeedback = data.feedback;
          }.bind(this)
        )
        .catch(
          function () {
            this.selectedFeedback = null;
          }.bind(this)
        )
        .finally(
          function () {
            this.hideLoading();
            this.activeViewPrompt = true;
            this.loading = false;
          }.bind(this)
        );
    },
    initPage() {
      this.showLoading();
      feedbacksService
        .filter(this.filter)
        .then(
          function (data) {
            this.feedbackSummary = data.customers_satisfaction;

            this.feedback = data.feedback.data;
            this.rating = data.rating;
            this.totalPages = data.feedback.last_page;
            this.totalItems = data.feedback.total;
            // this.currentPage = data.feedback.last_page;
            this.$t("Components.Feedback.Content").map(
              (content, index) => (this.steps[index].content = content)
            );
            this.$route.query.istour &&
            localStorage.getItem("skipTour") != "true"
              ? this.$tours["Feedback"].start()
              : "";
          }.bind(this)
        )
        .finally(() => {
          this.hideLoading();
        });
    },
    showLoading() {
      this.$vs.loading({
        container: "#feedback-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#feedback-box > div.con-vs-loading");
    },
    handleChangePage(page) {
      this.showLoading();
      feedbacksService
        .getPageFilter(page, this.filter)
        .then((data) => {
          this.feedback = data.feedback.data;
          this.currentPage = data.feedback.current_page;
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    ...mapActions("account", ["updateUserObject"]),
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    createdAt(date) {
      return this.$moment(date).fromNow();
    },
    goToNextPage() {
      router.push({ path: "/statistics?istour=on" });
    },
    filterByBuisiness(selected) {
      this.reloadComponents = true;
      this.filter.agency = selected.map((obj) => {
        return obj.id;
      });
      this.$nextTick(() => {
        this.reloadComponents = false;
      });
    },
  },
  computed: {
    ...mapState({
      account_info: (state) => state.account.user.user,
      business_info: (state) => state.account.user.business,
    }),
  },
  mounted() {
    this.initPage();
  },
  components: {
    FeedbackSummary,
    BusinessSelectFilter,
  },
};
</script>

<style scoped>
.badge-services {
  padding: 4px;
  margin-right: 6px;
  background-color: var(--primary);
  color: white;
  border-radius: 5px;
}
</style>

<style>
.feedback .vs-popup {
        max-width: 430px !important;
    }
</style>